import * as Sentry from "@sentry/browser";
import { QueryClientProvider } from "@tanstack/react-query";
import { ConnectedRouter } from "connected-react-router";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch } from "react-router";
import { store } from "tsx/store";
import { history } from "tsx/store/history";
import "whatwg-fetch";

import { AppFrameProvider } from "@livechat/design-system-react-components";

import { App } from "routes/App";
import NoAuthRouter from "routes/_no-auth";
import { getInitialTheme, setTheme } from "themes/helpers";

import "./_assets/less/index.less";
import { config } from "./config";
import { queryClient } from "./queryClient";

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    environment: config.env,
    //TODO: remove ignoreErrors after fixing the issue HD-4008
    ignoreErrors: [
      "ResizeObserver loop limit exceeded",
      "ResizeObserver loop completed with undelivered notifications",
      "ReferenceError: structuredClone is not defined",
    ],
    denyUrls: [/hs-analytics\.net/i, /hs-scripts\.com/i], // ignore HubSpot analytics and scripts errors
    beforeSend(event: Sentry.Event, hint: Sentry.EventHint) {
      const error = hint.originalException as Error;
      if (error && error.message && error.message.includes("Non-Error promise rejection captured with value")) {
        return null;
      }
      return event;
    },
  });
}

// SECOND SET THEME: change theme before user settings are fetched
const initialTheme = getInitialTheme();
setTheme(initialTheme);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <AppFrameProvider>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path={["/rate", "/notifications", "/requester"]} component={NoAuthRouter} />
            <App />
          </Switch>
        </ConnectedRouter>
      </AppFrameProvider>
    </Provider>
  </QueryClientProvider>,
  document.getElementById("root")
);
